<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import ConversationCard from 'dashboard/components-next/Conversation/ConversationCard/ConversationCard.vue';

const { t } = useI18n();
const route = useRoute();

const conversations = useMapGetter(
  'contactConversations/getAllConversationsByContactId'
);
const contactsById = useMapGetter('contacts/getContactById');
const stateInbox = useMapGetter('inboxes/getInboxById');
const accountLabels = useMapGetter('labels/getLabels');
const accountLabelsValue = computed(() => accountLabels.value);

const convUiFlags = useMapGetter('contactConversations/getUIFlags');
const isFetchingConversations = computed(() => convUiFlags.value.isFetching);

const contactConversations = computed(() =>
  conversations.value(route.params.contactId)
);
</script>

<template>
  <div>
    <div class="pt-2">
      <h4
        class="px-6 pt-4 pb-2 text-xs font-semibold uppercase text-n-slate-11"
      >
        {{ t('CONTACTS_LAYOUT.SIDEBAR.HISTORY.CONVERSATION_HISTORY') }}
      </h4>
      <div
        v-if="isFetchingConversations"
        class="flex items-center justify-center py-6 text-n-slate-11"
      >
        <Spinner />
      </div>
      <div
        v-else-if="contactConversations.length > 0"
        class="px-6 py-2 divide-y divide-n-strong [&>*:hover]:!border-y-transparent [&>*:hover+*]:!border-t-transparent"
      >
        <ConversationCard
          v-for="conversation in contactConversations"
          :key="conversation.id"
          :conversation="conversation"
          :contact="contactsById(conversation.meta.sender.id)"
          :state-inbox="stateInbox(conversation.inboxId)"
          :account-labels="accountLabelsValue"
          class="rounded-none hover:rounded-xl hover:bg-n-alpha-1 dark:hover:bg-n-alpha-3"
        />
      </div>
      <p v-else class="px-6 py-4 text-sm text-center text-n-slate-11">
        {{ t('CONTACTS_LAYOUT.SIDEBAR.HISTORY.EMPTY_STATE') }}
      </p>
    </div>
  </div>
</template>
